import { render } from "./AboutUs.vue?vue&type=template&id=32186fc8&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=32186fc8&scoped=true&lang=css"

import exportComponent from "/Users/ezink/Downloads/vue-antd-tool-web 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32186fc8"]])

export default __exports__